
import filters from '@js/user-backend/filters';
import ErrorHandler from '@js/ErrorHandler';
import managed from '@js/mixins/managed';

export default {
	install(Vue) {
		/* Plugins */
		Vue.use(filters);
		Vue.use(ErrorHandler);

		/* Mixins */
		Vue.mixin({
			methods: {
				managed
			}
		});
	}
};
